import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class CreateOrderErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [{
                'code': 'duplicated_non_editable_order',
                'text': 'There is another order for customer, delivery site and delivery_date',
                'data': {'state': 'PENDING',
                    'delivery_site_name': 'Fake Punto de Entrega',
                    'delivery_date': '2024-05-05 REVISAR',
                    'creation_date': '2024-05-05 REVISAR',
                    'creator_name': 'Usuario Desconocido'}
            }]
        }
    }

    static errorCodes() {
        return ['duplicated_editable_order', 'duplicated_non_editable_order', 'incorrect_delivery_date_for_delivery_site'];
    }
}